import { LoadingSpinner, mqMin, tok, tokPx } from '@sunwebgroup/ui-components'
import { styled } from 'styled-components'

export const Wrapper = styled.div`
  max-width: ${tokPx('primitives_area_size_1440')};
  margin: 0 auto;
  padding: ${tokPx('primitives_space_16')};

  @media ${mqMin('primitives_breakpoint_m_min')} {
    padding: ${tokPx('primitives_space_12')} ${tokPx('primitives_space_20')};
  }
`
export const Content = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  flex-direction: column;
  padding-bottom: ${tokPx('primitives_space_48')};
  gap: ${tokPx('semantics_layouts_m_gap')};

  @media ${mqMin('primitives_breakpoint_m_min')} {
    gap: ${tokPx('semantics_layouts_l_gap')};
  }

  @media ${mqMin('primitives_breakpoint_l_min')} {
    flex-direction: row;
    padding-bottom: ${tokPx('primitives_space_0')};
  }
`
export const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${tokPx('semantics_layouts_m_gap')};

  @media ${mqMin('primitives_breakpoint_l_min')} {
    gap: ${tokPx('semantics_layouts_l_gap')};
    margin-bottom: ${tokPx('primitives_space_80')};
    width: calc(((100% / 3) * 2) + (${tokPx('semantics_layouts_l_gap')} * 2));
  }
`
export const SideBarContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokPx('semantics_layouts_m_gap')};
  width: 100%;

  @media ${mqMin('primitives_breakpoint_l_min')} {
    gap: ${tokPx('semantics_layouts_l_gap')};
    max-width: ${tokPx('primitives_area_size_400')};
    min-width: ${tokPx('primitives_area_size_280')};
    width: calc(100% / 3);
  }
`
export const PageLayout = styled.div`
  background: ${tok('semantics_views_tinted_background_color')};
  min-height: 100vh;
`
export const Loader = styled(LoadingSpinner)`
  margin: 80px auto auto auto;
`
